<!-- NotesApp Source File: home.component.html  -->

<app-global-dialog></app-global-dialog>
<alert></alert>
<div
  class="bg-surface-100 dark:bg-surface-950 min-h-screen p-0.5 flex flex-col home-root"
  [ngClass]="{ 'select-mode-active': isSelectMode }"
  [style.--homeZoom]="homeZoomScale">
  <div class="home-zoom-layer">

    <app-header
      [categories]="categories"
      [projects]="projects"
      [tags]="availableTags"
      [statusValues]="statusValues"
      [isOnline]="connectivity.fullyOnline"
      [connectivityLabel]="connectivity.label"
      [types]="types"
      [isSelectMode]="isSelectMode"
      [externalFilter]="filter"
      [clearFilterTooltip]="clearFilterButtonTitle"
      (headerMenuAction)="onPageMenuAction($event)"
      (searchChanged)="onSearchChanged($event)"
      (filterChanged)="onFilterChanged($event)">
    </app-header>

    <app-bulk-action-dialog
      [visible]="bulkDialogVisible"
      [action]="currentBulkAction"
      [categories]="categories"
      [statuses]="statusValues"
      [tags]="availableTags"
      [removableTags]="bulkRemovableTags"
      [selectedCount]="selectedNoteIds.length"
      (cancel)="onBulkActionDialogCancel()"
      (submit)="onBulkActionDialogSubmit($event)">
    </app-bulk-action-dialog>

    <p-dialog
      header="Set Favorite (future!)"
      [(visible)]="favoriteDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '26rem', maxWidth: '90vw' }"
      appendTo="body"
      (onHide)="onFavoriteDialogCancel()">
      <div class="space-y-3">
        <div class="flex items-center gap-2">
          <input
            id="favoriteToggle"
            type="checkbox"
            class="h-4 w-4"
            [(ngModel)]="favoriteDialogFavorite" />
          <label for="favoriteToggle" class="text-sm">Favorite</label>
        </div>
        <div class="flex items-center gap-2">
          <input
            id="favoriteUpdateTimestampToggle"
            type="checkbox"
            class="h-4 w-4"
            [(ngModel)]="favoriteDialogUpdateTimestamp" />
          <label for="favoriteUpdateTimestampToggle" class="text-sm">Update timestamp</label>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 w-full">
          <p-button label="Cancel" severity="secondary" (onClick)="onFavoriteDialogCancel()"></p-button>
          <p-button label="Apply" (onClick)="onFavoriteDialogApply()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      header="App Info"
      [(visible)]="appInfoDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '32rem', maxWidth: '92vw' }"
      appendTo="body">
      <div class="space-y-3 text-sm">
        <div *ngIf="appVersionLoading" class="text-surface-600">Loading version info...</div>
        <div *ngIf="!appVersionLoading && appVersionError" class="text-red-600">{{ appVersionError }}</div>

        <div *ngIf="!appVersionLoading && appVersionInfo" class="space-y-2">
          <div><strong>Release:</strong> {{ appVersionInfo.release }}</div>
          <div><strong>Build:</strong> {{ appVersionInfo.buildVersion }}</div>
          <div><strong>Release Date:</strong> {{ appVersionDisplayBuiltAt }}</div>
          <div *ngIf="appVersionInfo.gitHash"><strong>Git:</strong> {{ appVersionInfo.gitHash }}</div>
          <div><strong>Source:</strong> {{ appVersionInfo.source === 'version.json' ? 'Deployment marker' : 'Local fallback' }}</div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 w-full">
          <p-button label="Refresh" severity="secondary" (onClick)="refreshAppInfoDialog()"></p-button>
          <p-button label="Close" (onClick)="appInfoDialogVisible = false"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    @if (isSelectMode) {
        <div class="mx-3 mb-4 flex flex-wrap items-center justify-between
            gap-3 rounded-2xl border border-primary/60 bg-primary/15 
            px-4 py-3 text-sm text-primary-900 shadow-inner">
            <div class="flex flex-wrap items-center gap-2">
                <p-tieredMenu #bulkActionsMenu [model]="bulkActionMenuItems" [popup]="true"
                  appendTo="body"> </p-tieredMenu>
                <button
                type="button"
                class="rounded-full border border-primary/50 px-4 py-1 text-xs 
                    font-semibold tracking-wide text-primary-700 transition hover:bg-white"
                (click)="bulkActionsMenu.toggle($event)">
                <span class="flex items-center gap-1">
                    Actions
                    <i class="pi pi-chevron-down text-[10px]"></i>
                </span>
                </button>
                <button type="button"
                class="rounded-full border border-primary/50 px-4 py-1 text-xs
                    font-semibold tracking-wide text-primary-700 transition hover:bg-white"
                  (click)="selectAllFilteredNotes()">
                  Select All
                </button>
                <button type="button"
                class="rounded-full border border-primary/50 px-4 py-1 text-xs
                  font-semibold tracking-wide text-primary-700 transition hover:bg-white"
                    (click)="clearSelectedNotes()">
                    Clear Selection
                </button>
                <div class="ml-3">
                    <div class="font-semibold tracking-wide">Select mode active</div>
                    <div class="text-xs text-primary-700">
                        {{ selectedNoteIds.length }} note(s) selected
                    </div>
                </div>
            </div>
            <div class="flex items-center gap-2">
                <button
                type="button"
                class="rounded-full bg-primary px-4 py-1 text-xs 
                    font-semibold tracking-wide text-white shadow hover:bg-primary-600"
                (click)="selectMode()">
                Exit Select Mode
                </button>
            </div>
        </div>
    }

    @if (isSemanticSearchActive && (semanticSearchLoading || semanticSearchError)) {
      <section class="mx-3 mb-4 rounded-xl border border-slate-200 bg-white p-4 space-y-2">
        @if (semanticSearchLoading) {
          <div class="text-sm text-slate-500">Searching...</div>
        }

        @if (!semanticSearchLoading && semanticSearchError) {
          <div class="text-sm text-red-600">{{ semanticSearchError }}</div>
        }
      </section>
    }

    <!-- ── Quick-Access split layout ─────────────────────────────────────── -->
    <div class="home-content-scroll-region flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
    <ng-container *ngIf="!isQaSmallScreen; else qaViewDirect">
      <ng-container *ngIf="!quickAccessCollapsed; else qaCollapsed">
        <p-splitter
          layout="horizontal"
          [panelSizes]="quickAccessSizes"
          [minSizes]="[8, 30]"
          [gutterSize]="5"
          styleClass="h-full w-full !border-0 !shadow-none"
          (onResizeEnd)="onQuickAccessResize($event)">
          <ng-template pTemplate="panel">
            <app-quick-access
              [notes]="allNotes"
              [filteredNotes]="filteredNotes"
              [availableTags]="availableTags"
              [filter]="filter"
              [isSelectMode]="isSelectMode"
              [selectedNoteIds]="selectedNoteIds"
              (selectedNoteIdsChange)="selectedNoteIds = $event"
              (relatedTagSelected)="onQuickAccessRelatedTagSelected($event)"
              (relatedTagRemoved)="onQuickAccessRelatedTagRemoved($event)"
              (relatedTagExcluded)="onQuickAccessRelatedTagExcluded($event)"
              (collapsePanel)="collapseQuickAccess()">
            </app-quick-access>
          </ng-template>
          <ng-template pTemplate="panel">
            <div class="home-view-scroll-region flex flex-col h-full overflow-y-auto">
              <ng-container *ngTemplateOutlet="viewContent"></ng-container>
            </div>
          </ng-template>
        </p-splitter>
      </ng-container>
    </ng-container>

    <ng-template #qaCollapsed>
      <div class="flex min-h-0 h-full">
        <button
          type="button"
          class="qa-expand-btn flex-shrink-0"
          (click)="expandQuickAccess()"
          title="Expand Quick Access">
          <span class="material-icons text-base" aria-hidden="true">chevron_right</span>
        </button>
        <div class="home-view-scroll-region flex-1 min-w-0 overflow-y-auto">
          <ng-container *ngTemplateOutlet="viewContent"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #qaViewDirect>
      <div class="home-view-scroll-region h-full overflow-y-auto">
        <ng-container *ngTemplateOutlet="viewContent"></ng-container>
      </div>
    </ng-template>

    <!-- All view content wrapped in a named template -->
    <ng-template #viewContent>
      @if (selectedView === 'Projects') {
        <app-project-cards
          [notes]="filteredNotes" [projects]="projects" [filter]="filter">
        </app-project-cards>
      }

      @if (selectedView === 'CardView') {
        <cards-view
          [notes]="filteredNotes"
          [categories]="categories"
          [filter]="filter"
          [filterCategories]="filter.Categories"
          [isSelectMode]="isSelectMode"
          [(selectedNoteIds)]="selectedNoteIds"
          (clickCategoryAction)="onCategoryClicked($event)">
        </cards-view>
      }

      @if (selectedView === 'Categories') {
        <app-category-cards
          [notes]="filteredNotes"
          [categories]="categories"
          [filter]="filter"
          [filterCategories]="filter.Categories"
          [isSelectMode]="isSelectMode"
          [(selectedNoteIds)]="selectedNoteIds"
          (clickCategoryAction)="onCategoryClicked($event)">
        </app-category-cards>
      }

      @if (selectedView === 'Tags') {
        <app-tag-cards
          [notes]="filteredNotes"
          [tags]="availableTags"
          [filter]="filter"
          [filterTagIds]="filter.TagIds"
          [isSelectMode]="isSelectMode"
          [(selectedNoteIds)]="selectedNoteIds"
          (clickTagAction)="onTagClicked($event)">
        </app-tag-cards>
      }

      @if (selectedView === 'List') {
        <app-list
          [tags]="availableTags"
          [notes]="filteredNotes"
          [categories]="categories"
          [filter]="filter"
          [isSelectMode]="isSelectMode"
          [(selectedNoteIds)]="selectedNoteIds">
        </app-list>
      }

      @if (selectedView === 'Calendar') {
        <app-calendar-view
          [notes]="filteredNotes"
          [tags]="availableTags"
          [filter]="filter"
          [initialMonth]="calendarMonthState"
          [initialVisibility]="calendarVisibilityState"
          (monthChanged)="onCalendarMonthChanged($event)"
          (visibilityChanged)="onCalendarVisibilityChanged($event)">
        </app-calendar-view>
      }
    </ng-template>
    <!-- ── end Quick-Access split layout ─────────────────────────────────── -->
    </div>
  </div>

    @if (isSelectMode) {
        <div class="select-mode-overlay pointer-events-none">
            <div class="select-mode-overlay__inner">
            <span class="material-icons text-lg" aria-hidden="true"> bolt </span>
            <span>Select Mode Enabled</span>
            </div>
        </div>
    }

  <!-- Floating Action Button -->
  <div class="fixed z-50 home-fab" 
        style="right: 1.5rem; bottom: calc(3.25rem + env(safe-area-inset-bottom))">
    <p-menu #templateFabMenu [model]="templateMenuItems" [popup]="true" appendTo="body"></p-menu>
    <div class="home-fab-actions">
      <p-button
        type="button"
        icon="pi pi-plus"
        styleClass="fab-main-button"
        (onClick)="createNewNote()">
      </p-button>
      <p-button
        type="button"
        icon="pi pi-chevron-down"
        styleClass="fab-menu-button"
        aria-label="Create from template"
        (onClick)="onTemplateMenuOpened(); templateFabMenu.toggle($event)">
      </p-button>
    </div>
  </div>

  <!-- Create from Template Dialog -->
  <p-dialog
    header="Create from Template"
    [(visible)]="templateDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '560px', maxWidth: '95vw' }"
    appendTo="body">

    @if (templatesLoading) {
    <div class="flex items-center gap-2 text-sm text-surface-600">
        <i class="pi pi-spin pi-spinner"></i>
        Loading templates...
    </div>
    }

    @if (!templatesLoading && templateLoadError) {
    <div class="text-sm text-red-600">
        {{ templateLoadError }}
    </div>
    }

    @if (!templatesLoading && !templateLoadError && templates.length === 0) {
    <div class="text-sm text-surface-600">
        No templates found. Save a note as a template to get started.
    </div>
    }

    @if (!templatesLoading && templates.length) {
    <div class="flex flex-col gap-2">
        <div
        *ngFor="let template of templates"
        class="flex items-center justify-between gap-3 rounded-lg border 
            border-surface-200 px-3 py-2">
        <div class="min-w-0">
            <div class="font-semibold truncate">
            {{ template.templateName || template.Title || 'Untitled template' }}
            </div>
            <div class="text-xs text-surface-500">
            {{ stripHtml(template.DescriptionHtml || '').slice(0, 80) }}
            </div>
        </div>
        <p-button label="Use" icon="pi pi-arrow-right" 
            (onClick)="createNoteFromTemplate(template)"></p-button>
        </div>
    </div>
    }

    <ng-template pTemplate="footer">
    <p-button
        label="Close"
        severity="secondary"
        icon="pi pi-times"
        (onClick)="templateDialogVisible = false"></p-button>
    </ng-template>
</p-dialog>

  <!-- Synch Status Dialog -->
  <p-dialog
    header="Synch Status Dialog"
    [(visible)]="showSyncDialog"
    [modal]="false"
    [closable]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    [style]="{ width: '64rem', maxWidth: '95vw', height: '550px' }"
    [draggable]="true"
    [resizable]="true"
    appendTo="body"
    [baseZIndex]="10000"
    styleClass="sync-dialog"
    (onHide)="onSyncDialogHide()">
    <!-- Body: status + messages -->
    <div class="space-y-3 h-full flex flex-col">
      <div class="grid grid-cols-2 gap-4">
        <div class="flex items-center gap-2 min-w-0">
          <span class="font-medium">CouchDB:</span>
          <span
            [ngClass]="{
              'text-green-600': syncStatus.couchdb === 'ok',
              'text-yellow-600': syncStatus.couchdb === 'syncing',
              'text-red-600': syncStatus.couchdb === 'error' || 
                  syncStatus.couchdb === 'offline'
            }">
            {{ syncStatus.couchdb === 'offline' ? (connectivity.level === 'server-unreachable' ? 'Server Unreachable' : 'Offline') : (syncStatus.couchdb | titlecase) }}
          </span>
        </div>

        <div class="flex items-center gap-2 min-w-0">
          <span class="font-medium">IndexedDB:</span>
          <span
            [ngClass]="{
              'text-green-600': syncStatus.indexeddb === 'ok',
              'text-yellow-600': syncStatus.indexeddb === 'syncing',
              'text-red-600': syncStatus.indexeddb === 'error' || 
              syncStatus.indexeddb === 'offline'
            }">
            {{ syncStatus.indexeddb | titlecase }}
          </span>
        </div>
      </div>

      @if (syncStatus.lastSynced) {
        <div class="text-xs text-surface-500 dark:text-surface-400">
          Last sync: {{ syncStatus.lastSynced | date : 'short' }}
        </div>
      }
      <!-- Messages area -->
      <div #syncLogContainer class="border rounded p-2 flex-1 min-h-40 overflow-auto 
            bg-surface-50 dark:bg-surface-800">
            <div class="whitespace-pre-wrap text-sm" 
                *ngFor="let m of (synchLog$ | async) ?? []; trackBy: trackByIndex">
                • {{ m }}
            </div>

        @if (!(synchLog$ | async)?.length) {
          <div class="text-sm italic text-surface-500 dark:text-surface-400">
            No messages yet.
          </div>
        }
      </div>
    </div>

    <!-- Synch Status Footer -->
    <ng-template pTemplate="footer">
      <div class="sync-dialog-footer flex justify-end gap-2">
        <p-button
          label="Info"
          icon="pi pi-info-circle"
          styleClass="sync-dialog-btn"
          severity="secondary"
          (onClick)="getDbInfos()"></p-button>
        <p-button
          label="Synch-List"
          icon="pi pi-list"
          styleClass="p-button-info sync-dialog-btn"
          routerLink="/sync-list"></p-button>
        <p-button
          label="Synch Now"
          icon="pi pi-sync"
          styleClass="sync-dialog-btn"
          [loading]="isSyncing"
          (onClick)="synchNow()"></p-button>
        <p-button
          label="Force Baseline Sync"
          icon="pi pi-exclamation-triangle"
          styleClass="sync-dialog-btn"
          severity="danger"
          (onClick)="forceBaselineConfirmed()"></p-button>
        <p-button
          label="Clear Log"
          icon="pi pi-trash"
          styleClass="sync-dialog-btn"
          severity="secondary"
          (onClick)="clearSynchLog()"></p-button>
        <p-button
          label="Close"
          severity="secondary"
          icon="pi pi-times"
          styleClass="sync-dialog-btn sync-dialog-btn--full"
          (onClick)="closeSyncDialog()"></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- FOOTER BAR -->
  <div class="home-footer">
    <div class="flex gap-2 items-center">
      <p-button #zoomTrigger text class="home-icon-button" (click)="toggleZoomPanel($event)">
        <ng-template pTemplate="icon">
          <span class="material-symbols-outlined">zoom_in</span>
        </ng-template>
      </p-button>
    </div>
    <div class="flex gap-4 items-center">
      <div class="home-footer-filter-status flex items-center gap-1.5">
        <span>{{ isFiltered ? 'Filtered' : 'Unfiltered' }}</span>
        <span aria-hidden="true">|</span>
        <span>{{ displayedNotesCount }} record{{ displayedNotesCount !== 1 ? 's' : '' }}</span>
        <button
          type="button"
          class="home-footer-filter-info-button"
          aria-label="Show filter details"
          title="Show active filter details"
          (click)="openFilterInfoDialog()">
          i
        </button>
      </div>
      <div class="flex items-center gap-2">
        <span
          class="home-footer-online-indicator cursor-pointer"
          role="button"
          tabindex="0"
          [ngClass]="{ 'online': connectivity.fullyOnline, 'offline': !connectivity.fullyOnline }"
          [attr.aria-label]="connectivity.label"
          [title]="connectivity.label"
          (click)="connectivityPopover.toggle($event)"
          (keydown.enter)="connectivityPopover.toggle($event)">
          <span class="material-symbols-outlined home-footer-status-icon"
            [ngClass]="connectivity.fullyOnline ? 'home-footer-status-icon--online' : 'home-footer-status-icon--offline'">{{ connectivity.icon }}</span>
        </span>
        <div class="home-footer-status">{{ globalStatusMessage }}</div>
      </div>
    </div>
  </div>

  <p-popover #connectivityPopover [dismissable]="true" appendTo="body" styleClass="connectivity-status-popover">
    <div class="connectivity-status-popover__content">{{ connectivityPopoverMessage }}</div>
  </p-popover>

  <p-dialog
    header="Current Filter Details"
    [(visible)]="filterInfoDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '44rem', maxWidth: '96vw' }"
    appendTo="body"
    styleClass="filter-info-dialog">
    <div class="filter-info-dialog__summary">
      <div><strong>State:</strong> {{ isFiltered ? 'Filtered' : 'Unfiltered' }}</div>
      <div><strong>Hit Count:</strong> {{ displayedNotesCount }}</div>
      <div><strong>Total Notes:</strong> {{ allNotes.length }}</div>
      <div><strong>Current View:</strong> {{ selectedView }}</div>
    </div>

    <div class="filter-info-dialog__human-wrap">
      <div class="filter-info-dialog__label"><strong>Active filters:</strong></div>
      <div class="filter-info-dialog__human-content">
        <div *ngIf="currentFilterHumanReadable.length === 0" class="filter-info-dialog__empty">
          No active filters.
        </div>
        <div *ngIf="currentFilterHumanReadable.length > 0" class="filter-info-dialog__human-list">
          <div class="filter-info-dialog__human-row" *ngFor="let row of currentFilterHumanReadable">
            <div class="filter-info-dialog__human-label">{{ row.label }}</div>
            <div class="filter-info-dialog__human-value">{{ row.value }}</div>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        label="JSON"
        icon="pi pi-code"
        severity="contrast"
        outlined="true"
        (onClick)="openFilterInfoJsonDialog()">
      </p-button>
      <p-button
        label="Close"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="filterInfoDialogVisible = false">
      </p-button>
    </ng-template>
  </p-dialog>

  <p-dialog
    header="Current Filter JSON"
    [(visible)]="filterInfoJsonDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '44rem', maxWidth: '96vw' }"
    appendTo="body"
    styleClass="filter-info-dialog">
    <div class="filter-info-dialog__json-wrap">
      <div class="filter-info-dialog__label">Active Filter (JSON)</div>
      <pre class="filter-info-dialog__json">{{ currentFilterDisplay }}</pre>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        label="Close"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="filterInfoJsonDialogVisible = false">
      </p-button>
    </ng-template>
  </p-dialog>

  <!-- Zoom Panel -->
  <div
    #zoomPanel
    *ngIf="showZoomPanel"
    class="home-zoom-panel"
    (click)="$event.stopPropagation()">
    <div class="home-zoom-panel__header">
      <span class="home-zoom-panel__title">System Zoom</span>
      <button class="home-zoom-panel__close" type="button" (click)="showZoomPanel = false">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
    <div class="home-zoom-panel__body">
      <p-slider
        [(ngModel)]="systemZoomFactor"
        [min]="50"
        [max]="400"
        [step]="1"
        (onChange)="onSystemZoomChange($event)"
        (onSlideEnd)="persistSystemZoom()">
      </p-slider>
      <div class="home-zoom-panel__value">{{ systemZoomFactor }}%</div>
    </div>
  </div>
</div>
